import { INTENTION_TYPE } from '../models/Intention.enums'

const VALID_INTENTION_TYPES = new Set<string>([
  INTENTION_TYPE.ARRIVAL,
  INTENTION_TYPE.BIRTHDAY,
  INTENTION_TYPE.INTENTION,
])

export const isIntentionTypeValid = (type: string): boolean => VALID_INTENTION_TYPES.has(type)
